// prevent load spr.js
if (document.getElementsByClassName('template-product').length==0) {
  const insertBeforeElementBackup = Element.prototype.insertBefore
  Element.prototype.insertBefore= function(...args) {   
    if(!args[0].outerHTML || (args[0].outerHTML && args[0].outerHTML.indexOf("spr.js") ==-1))        
    return insertBeforeElementBackup.apply(this,args)
  }
}

//prevent load font awesome  from 3rd party
const appendElementBackup = Element.prototype.appendChild;
Element.prototype.appendChild= function(...args) { 
  if (args[0].nodeName && args[0].nodeName=='SCRIPT' && args[0].src.indexOf('jquery.min.js')!=-1) {
    if (window.SPR!=undefined) {
      $.ajaxSetup({ cache: !0 }),
      SPR.loadjQueryExtentions($),
      $(document).ready(function () {
        SPR.$=jQuery;
    return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges();
      })
    }
    return ;
  }
 if(!args[0].outerHTML || (args[0].outerHTML && args[0].outerHTML.indexOf("maxcdn.bootstrapcdn.com/font-awesome/4.6.3/css/font-awesome.min.css") ==-1))      
   return appendElementBackup.apply(this,args)
}

if ($('link[href="https://maxcdn.bootstrapcdn.com/font-awesome/4.4.0/css/font-awesome.min.css"]').length>0)
$('link[href="https://maxcdn.bootstrapcdn.com/font-awesome/4.4.0/css/font-awesome.min.css"]').remove()

var W_width = $(window).width(), W_height = $(window).height();
$(window).on('resize', function () {
  if($(window).width() != W_width || $(window).height() != W_height){
    W_width = $(window).width();
    W_height = $(window).height();
    _initResize();
  }
});
$(window).on('load', function () {
  _initResize();
});

// Filters
function _initResize() {
  $('.filter-refine').off('click');
  $('.filter-overlay, .filter__close, .filter__apply').off('click');
  $('.filter-sort__title').off('click');
  $(document).off('click.resize');
  $('.filter-sort-overlay').removeClass('filter-sort-overlay--active');
  $('.filters__container').removeClass('filters__container--sticky');
  $('html').removeClass('no-scroll');
  $('.filter-sort__list').css('display','');
  $('.filter-sort').off('click');
  // Filters Mobile/Tablet
if ($(window).width() < 1365) {
  // Filters - Open
  $('.filter-refine').on('click', function () {
    $('.filter').toggleClass('filter--active');
    $('.filters__container').removeClass('filters__container--sticky');
    $('.filter-overlay').addClass('filter-overlay--active');
    $('html').addClass('no-scroll');
    return false;
  });

  // Filter - Close
  $('.filter-overlay, .filter__close, .filter__apply').on('click', function () {
    $('.filter').removeClass('filter--active');
    $('.filter-overlay').removeClass('filter-overlay--active');
    $('html').removeClass('no-scroll');
    return false;
  });
}

// Sort Tablet/Desktop
if ($(window).width() > 599) {
  $('.filter-sort__title').on('click',function(e) {
    e.preventDefault();
  
    var $this = $(this);
  
    if ($this.next().hasClass('filter-sort__list--active')) {
      $this.next().removeClass('filter-sort__list--active');
      $this.next().slideUp(150);
    } else {
      $this.parent().parent().find('.filter-sort .filter-sort__list').removeClass('filter-sort__list--active');
      $this.parent().parent().find('.filter-sort .filter-sort__list').slideUp(150);
      $this.next().toggleClass('filter-sort__list--active');
      $this.next().slideToggle(150);
    }

    if ($this.hasClass('filter-sort__title--active')) {
      $this.removeClass('filter-sort__title--active');
      $this.attr('aria-expanded','false');
    } else {
      $this.attr('aria-expanded','true');
      $this.parent().find('.filter-sort .filter__title').removeClass('filter-sort__title--active');
      $this.toggleClass('filter-sort__title--active');
    }

  });

  $(document).on('click.resize',function (e) {
    if (!$(e.target).is(".filter-sort *")) {
      $('.filter-sort__list').removeClass('filter-sort__list--active');
      $('.filter-sort__title').removeClass('filter-sort__title--active');
      $('.filter-sort__list').slideUp(150);
    }
  }); 
}

// Sort Mobile
if ($(window).width() < 600) {
  $('.filter-sort').on('click', function () {    
    $(this).children('.filter-sort__list').toggleClass('filter-sort__list--active');
    $('.filter-sort-overlay').toggleClass('filter-sort-overlay--active');
    $('.filters__container').removeClass('filters__container--sticky');
    $('html').toggleClass('no-scroll');
    return false;
  });
  $(document).on('click.resize',function (e) {
    if (!$(e.target).is(".filter-sort *") && !$(e.target).is(".filter__group *")) {
      $('.filter-sort__list').removeClass('filter-sort__list--active');
      $('.filter-sort-overlay').removeClass('filter-sort-overlay--active');
      $('html').removeClass('no-scroll');
      
    }
  }); 
}

// Header Scroll
previousScroll = 0;
headerOrgOffset = 0;
if ($(window).width() > 1365) {
  if ($('.header').length>0)  headerOrgOffset = $('.header').offset().top + 28;
} else {
  if ($('.header').length>0)  headerOrgOffset = $('.header').offset().top;
}
  
};
// Filters All
$(document).ready(function() {

  // loadswatches();
 _initFilter();

  // $(document).off('click').on('click',function(e) {
  //   if (!$(e.target).is(".filter__group *")) {
  //     $('.filter__list').removeClass('filter__list--active');
  //     $('.filter__title').removeClass('filter__title--active');
  //     $('.filter__list').slideUp(150);
  //   }
  // });

  $(document).on('click.filterClose', function (e) {
    if (!$(e.target).closest('.filter__group').length) {
      $('.filter__list')
        .removeClass('filter__list--active')
        .slideUp(150);

      $('.filter__title').removeClass('filter__title--active');
    }
  });

});

function _initFilter() {
   // Filter - Accordion
  $('.filter__title').off('click').on('click',function(e) {
    e.preventDefault();
  
    var $this = $(this);
  
    if ($this.next().hasClass('filter__list--active')) {
      $this.next().removeClass('filter__list--active');
      $this.next().slideUp(150);
      
    } else {
      $this.parent().parent().find('.filter__group .filter__list').removeClass('filter__list--active');
      $this.parent().parent().find('.filter__group .filter__list').slideUp(150);
      $this.parent().parent().find('.filter__group .filter__title').removeClass('filter__title--active');
      $this.next().toggleClass('filter__list--active');
      $this.next().slideToggle(150);
    }

    if ($this.hasClass('filter__title--active')) {
      $this.removeClass('filter__title--active');
      $this.attr('aria-expanded','false');
    } else {
      $this.addClass('filter__title--active');
      $this.attr('aria-expanded','true');
    }

  });
}

// Canvas Cart
var dataOffcanvas;
$(document).ready(function() { 
  $( function(){

    $( document ).on( "beforecreate.offcanvas", function( e ){
      dataOffcanvas = $( e.target ).data('offcanvas-component');
    } );

    $( document ).on( "create.offcanvas", function( e ){
      var dataOffcanvas = $( e.target ).data('offcanvas-component');

    } );

    $( document ).on( "clicked.offcanvas-trigger clicked.offcanvas", function( e ){
      var dataBtnText = $( e.target ).text();
    } );

    $( document ).on( "open.offcanvas", function( e ){
      var dataOffcanvasID = $( e.target ).attr('id');
    } );

    $( document ).on( "resizing.offcanvas", function( e ){
      var dataOffcanvasID = $( e.target ).attr('id');
    } );

    $( document ).on( "close.offcanvas", function( e ){
      var dataOffcanvasID = $( e.target ).attr('id');
    } );

    $( document ).on( "destroy.offcanvas", function( e ){
      var dataOffcanvasID = $( e.target ).attr('id');
    } );

    $( '#bottom' ).on( "create.offcanvas", function( e ){
      var api = $(this).data('offcanvas-component');

      $('.js-destroy').on('click', function () {
        api.destroy();
        //$( '#top' ).data('offcanvas-component').destroy();
      });
    } );

    $( '#left' ).offcanvas( {
      modifiers: "left,overlay",
      triggerButton: '.js-offcanvas-trigger-left'
    } );

    $('.js-enhance').on('click', function () {
      $( document ).trigger( "enhance" );
    });

    $( document ).trigger( "enhance" );
    
  });
});

// Filter Switch
function setCookie(cname,cvalue) {
  var d = new Date();
  d.setTime(d.getTime() + (365*24*60*60*1000));
  var expires = "expires=" + d.toGMTString();
  if((typeof cvalue)!="string")   var cvalue_string=JSON.stringify(cvalue);
  else var cvalue_string=cvalue;
  document.cookie = cname + "=" + cvalue_string + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  } 
}


// Header Sticky
var previousScroll = 0;
var headerOrgOffset =0;
if ($('.header').length>0)  headerOrgOffset =$('.header').offset().top;

$(window).scroll(function () {
  if ($('.header').length>0) {
    var currentScroll = $(this).scrollTop();
    if (currentScroll > headerOrgOffset) {
      if (currentScroll > previousScroll) {
        $('html:not(".no-scroll") .header').removeClass('header--sticky');
        //$('html:not(".no-scroll") .boost-pfs-search-suggestion-mobile-top-panel').removeClass('boost-pfs-search-suggestion-mobile-top-panel--sticky');
      } else {
        $('html:not(".no-scroll") .header').addClass('header--sticky');
        //$('html:not(".no-scroll") .boost-pfs-search-suggestion-mobile-top-panel').addClass('boost-pfs-search-suggestion-mobile-top-panel--sticky');
      }
    } else {
      $('html:not(".no-scroll") .header').removeClass('header--sticky');
      //$('html:not(".no-scroll") .boost-pfs-search-suggestion-mobile-top-panel').removeClass('boost-pfs-search-suggestion-mobile-top-panel--sticky');
    }
    previousScroll = currentScroll;
  }
});

// Filter Sticky
if ($(".filters")[0]) {
  var previousScrollFilter = 0,
  headerOrgOffsetFilter = $('.filters').offset().top + (-62);

  $(window).scroll(function (e) {
    var currentScrollFilter = $(this).scrollTop();
    if (currentScrollFilter > headerOrgOffsetFilter) {
      if (currentScrollFilter > previousScrollFilter) {
        $('html:not(".no-scroll") .filters__container').removeClass('filters__container--sticky');
      } else {
        $('html:not(".no-scroll") .filters__container').addClass('filters__container--sticky');
      }
    } else {
      $('html:not(".no-scroll") .filters__container').removeClass('filters__container--sticky');
    }
    previousScrollFilter = currentScrollFilter;
  });
}

// Product Page - Sticky Button
$(document).on('scroll', function(){
  if ($(window).scrollTop() > 50){
    $('.product-add-mobile').addClass('product-add-mobile--sticky');
  } else {
    $('.product-add-mobile').removeClass('product-add-mobile--sticky');
  }
});

// // Header Search Toggle
$(document).ready(function() {
  $('.header-search__toggle').click(function () {
    $('.header-search__form').toggleClass('header-search__form--visible');
    $('.site-container').toggleClass('site-container--blackout');
    $('.header-search__input').focus();
  });
  $(document).click(function (e) {
    if (!$(e.target).is(".header *")) {
      $('.site-container').removeClass('site-container--blackout');
      $('.header-search__form').removeClass('header-search__form--visible');
    }
  });
});       

// Collection Description Toggle
$(document).ready(function() { 
  $('.collection__toggle').off('click').on('click', function () {
    $('.collection__description-content').toggleClass('collection__description-content--visible');
    $('.collection__show-hide').toggle();
    return false;
  });
});

// Footer Accordions
$(document).ready(function() { 
  $('.footer-content__accordion-header').off('click').on('click', function () {
    $(this).toggleClass('footer-content__accordion-header--shown');
    $(this).next('.footer-content__accordion-content').slideToggle(200);
    return false;
  });
});

// Currency Converter
$(document).ready(function() { 
  $('.shopify-currency-form select').on('change', function() {
    $(this)
      .parents('form')
      .submit();
  });
});

// Nav Mega Hover
$(".nav__mega .nav__sub-menu").css('display', 'grid').hide();
$(".nav__single .nav__sub-menu").css('display', 'block').hide();
$(".nav__dropdown").on("mouseenter", function (e) {
  if (window.innerWidth > 1279) {
    $('.nav-overlay').stop(!0, !0).delay(250).fadeIn();
    $(this).children(".nav__sub-menu").stop(!0, !0).delay(250).fadeIn();
    // $(this).children(".nav__link").children("span").stop(!0, !0).delay(250).fadeIn();
  }
});
$(".nav__dropdown").on("mouseleave", function (e) {
  if (window.innerWidth > 1279) {
    $('.nav-overlay').stop(!0, !0).delay(250).fadeOut();
    $(this).children(".nav__sub-menu").stop(!0, !0).delay(250).fadeOut();
    // $(this).children(".nav__link").children("span").stop(!0, !0).delay(250).fadeOut();
  }
});
// Keyboard interaction - only open on Enter
$(".nav__dropdown .nav__link").on("keydown", function (e) {
  if (e.key === "Enter") {
    const $submenu = $(this).closest(".nav__dropdown").children(".nav__sub-menu");
    if ($submenu.is(":visible")) {
      $submenu.stop(true, true).fadeOut(); // Close if already open
      $('.nav-overlay').stop(true, true).fadeOut();
    } else {
      $submenu.stop(true, true).fadeIn(); // Open if closed
      $('.nav-overlay').stop(true, true).fadeIn();
    }
    e.preventDefault(); // Prevent default Enter behavior
  }
});

// Finance Popup - Klarna
$('.product-finance__link--klarna-30').on('click', function () {
  $('.product-finance-popup--klarna-30').addClass('product-finance-popup--active');
  $('html').addClass('noscroll-finance-popup');
});
$('.product-finance__link--klarna').on('click', function () {
  $('.product-finance-popup--klarna').addClass('product-finance-popup--active');
  $('html').addClass('noscroll-finance-popup');
});

// Finance Popup - Clearpay
$('.product-finance__link--clearpay').on('click', function () {
  $('.product-finance-popup--clearpay').addClass('product-finance-popup--active');
  $('html').addClass('noscroll-finance-popup');
});

// Finance Popup - Laybuy
$('.product-finance__link--laybuy').on('click', function () {
  $('.product-finance-popup--laybuy').addClass('product-finance-popup--active');
  $('html').addClass('noscroll-finance-popup');
});

// Finance Popup - Zip
$('.product-finance__link--zip').on('click', function () {
  $('.product-finance-popup--zip').addClass('product-finance-popup--active');
  $('html').addClass('noscroll-finance-popup');
});

// Finance Popup - Close
$('.product-finance-popup__close').on('click', function () {
  $('.product-finance-popup').removeClass('product-finance-popup--active');
  $('html').removeClass('noscroll-finance-popup');
});

$(document).mouseup(function(e) {
  var container = $(".product-finance-popup *");
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $('.product-finance-popup--active').removeClass('product-finance-popup--active');
    $('html').removeClass('noscroll-finance-popup');
  }
});

// Add Class to Header on Scroll
$(window).scroll(function() {    
    var scroll = $(window).scrollTop();

    if (scroll >= 100) {
        $(".header").addClass("header--white");
    } else {
        $(".header").removeClass("header--white");
    }
});  

// Account Tabs
$('.account .tab').on('click', function () {
  var tab_id = $(this).attr('data-tab');
  $('.account__tab').removeClass('account__tab--active');
  $('.account__content').hide();
  $(this).addClass('account__tab--active');
  $("#"+tab_id).show();
});

// Mobile Nav
$(document).ready(function() { 
  
  // Featured Collection - Tabs
  $('.featured-collection-tabs__tab').off('click').on('click', function () {
    var tab = $(this).data('tab');
    $('.featured-collection-tabs__tab').removeClass('featured-collection-tabs__tab--active');
    $('.featured-collection-tabs__tab-content').removeClass('featured-collection-tabs__tab-content--active');
    $(this).addClass('featured-collection-tabs__tab--active');
    $('#' + tab).addClass('featured-collection-tabs__tab-content--active');
  });     
    
  // Clone
  $('.nav__sub-menu').each(function(){
    $(this).clone().addClass('nav__sub-menu--cloned').insertAfter(".header-nav").wrapInner("<ul class='nav__sub-menu__wrap'></ul>");
  });

  // Open & Close Nav (Mobile) - Click Function
  $('.header-mobile').off('click').on('click', function () {
    $(this).toggleClass('header-mobile--active');
    $('.header-announcements').toggleClass('header-announcements--hide');
    $('.header-nav').toggle();
    $('.header-nav').toggleClass('header-nav--active');
    $('html').toggleClass('no-scroll-mobile-nav');
    $('.mobile-nav-overlay').toggle();
    $('.nav__sub-menu--cloned').removeClass('nav__sub-menu--active');
    $('.nav').removeClass('nav--hidden');
  });

  // Close Nav (Mobile) - Click Function
  $('.mobile-nav-overlay').off('click').on('click', function () {
    $('.header-mobile').removeClass('header-mobile--active');
    $('.header-announcements').removeClass('header-announcements--hide');
    $('.header-nav').hide();
    $('.header-nav').removeClass('header-nav--active');
    $('html').removeClass('no-scroll-mobile-nav');
    $('.mobile-nav-overlay').hide();
    $('.nav').removeClass('nav--hidden');
    $('.nav__sub-menu--cloned').removeClass('nav__sub-menu--active');
  });

  // Open Sub Menu - Click Function
  $('.nav__dropdown .nav__link').off('click').on('click', function (event) {
    if ($(window).width() < 1280) {
      event.preventDefault();
    }
    var id = $(this).attr('id');
    $('.nav__sub-menu').each(function(){
      var dataid = $(this).attr('data-id');
      console.log(dataid);
      if(id == dataid) {
        $(this).addClass('nav__sub-menu--active');
      }
    });
    $('.nav').addClass('nav--hidden');
  });

  // Back Button - Click Function
  $('.nav__sub-menu__back').off('click').on('click', function () {
    $('.nav__sub-menu').removeClass('nav__sub-menu--active');
    $('.nav').removeClass('nav--hidden');
  });

});

// Run Functions
function _checkafterLoadEvents() {
  window.afterLoadWithEvents.forEach(x=> {
    if (x.evt && !$(x.el).is(document)) {
      if ( x.evt==arguments[0].type && $(x.el).is(arguments[0].target)) {
        $(x.el).off(x.evt+'.'+x.f)
          if (typeof(x.f)=='function') {
            setTimeout(x.f,0);
          }
        else {
          window[x.f].apply();
        }
        window.afterLoadWithEvents.splice(window.afterLoadWithEvents.indexOf(x),1);  
      }
    }
    else {
      if (typeof(x.f)=='function') {
        setTimeout(x.f,0);
      }
      else {
       window[x.f].apply();
      }
      window.afterLoadWithEvents.splice(window.afterLoadWithEvents.indexOf(x),1);  
    }  
  });
  if (window.afterLoadWithEvents.length==0) {
    $(window).off('scroll.afterLoad');
  }
}

function register() {
  jQuery('html').removeClass('no-js').addClass('js');
  if (window.ReadyScript) {
    window.ReadyScript.forEach(x=> {
      loadScript(x.s,x.c);
    });
  }
  if (window.afterLoad) {
    window.afterLoad.forEach(x=> {
      if (x.p!=undefined) {
        window[x.f].apply(x.p);      
      }
      else {
        window[x.f].apply();      
      }
    });    
  }
  
  if (window.afterLoadWithEvents) {
    $(window).on('scroll.afterLoad',_checkafterLoadEvents);
    window.afterLoadWithEvents.forEach(x=> {
      if (x.evt) {
        $(x.el).on(x.evt+'.'+x.f,_checkafterLoadEvents)
      }
    });
  }
}
  
// window.afterLoadWithEvents = window.afterLoadWithEvents || [];
//   window.afterLoadWithEvents.push(
//   {
//       f:"_register",
//       evt: 'mousemove',
//       el: document
//   });
// function _register() {
//   checkUserLocation();
// };
$(document).ready(function(){
  register(); 
  if ($('[data-cart-qty]').length>0) {
    $('[data-cart-qty]').on('focusout',function() {
      if (parseInt($(this).data('cart-qty'))!=parseInt($(this).val())) {
        $(this).closest('form').get(0).submit();
      }
    });
  }
});

// load scripts after page load
function loadScript(sc,callback) {
  if ($.isArray(sc)) {    
    let lc = document.createElement('script'); lc.type = 'text/javascript'; 
    lc.src = sc[0];
    sc.splice(0,1);   
    if (sc.length>0) {
      $(lc).on('load',function() {loadScript(sc,callback)});           ;
    }
    else if (callback!=undefined) {
    $(lc).on('load',function() {window[callback].apply()});   
    }
    document.getElementsByTagName('body')[0].appendChild(lc);
  } else {
    let lc = document.createElement('script'); lc.type = 'text/javascript'; 
    lc.src = sc;
    if (callback!=undefined) {
      $(lc).on('load',function() {window[callback].apply()});   
    }
    document.getElementsByTagName('body')[0].appendChild(lc);
  }
}

// For Theme Editor
document.addEventListener("shopify:section:load", function(event) {
  register();
});

document.addEventListener('lazybeforeunveil', function (e) {
  var bg = e.target.getAttribute('data-bg');
  if (bg) {
    e.target.style.backgroundImage = "url('" + bg + "')";
  }
});

// Product Page LightGallery Popup
if($("#lightgallery").length != 0) {
  lightGallery(document.getElementById('lightgallery'), {
    selector: '.product-images__item',
    plugins: [lgZoom, lgThumbnail],
    speed: 500,
    thumbnail: false,
    getCaptionFromTitleOrAlt: false,
    licenseKey: 'C1DB9144-799D4957-B3C1226F-C451F4A3',
    mobileSettings: { 
      controls: true, 
      showCloseIcon: true,
      download: false, 
    }
  });
}

// Gallery Page LightGallery Popup
if($("#lightgallerypage").length != 0) {
  lightGallery(document.getElementById('lightgallerypage'), {
    selector: '.gallery__image-link',
    plugins: [lgZoom, lgThumbnail],
    speed: 500,
    thumbnail: false,
    getCaptionFromTitleOrAlt: true,
    licenseKey: 'C1DB9144-799D4957-B3C1226F-C451F4A3',
    mobileSettings: { 
      controls: true, 
      showCloseIcon: true,
      download: false, 
    }
  });
}

// Swiper Video play and pause
var vids = $("video"); 
$.each(vids, function(){
  this.controls = false; 
}); 
$("video").click(function() {
  if (this.paused) {
    this.play();
  } else {
    this.pause();
  }
});
$("video").bind('stop pause', function(e) {
  console.log("stopped");
  $(this).parent().removeClass('responsive-video--stopped');
});

$("video").bind('play', function(e) {
  console.log("playing");
  $(this).parent().addClass('responsive-video--stopped');
});

// Swiper Slider - Default
if ($('.swiper--default').length > 0) {
  initSwipers();
}
var productImagesSwiper;
function initSwipers() {
  let swiperInstances = [];
  $(".swiper--default").each(function(index, obj){ 
    const $this = $(this);
    if (!$this.hasClass('swiper-initialized')) {
    $this.addClass("swiper-" + index); 
    $this.find(".swiper-pagination").addClass("pagination-" + index);
    $this.find(".swiper-button-prev").addClass("prev-" + index);
    $this.find(".swiper-button-next").addClass("next-" + index); 
    $this.find(".swiper-scrollbar").addClass("scrollbar-" + index);

    if($this.hasClass('swiper--autoplay')) {
      $autoplay = { delay: 4000 };
    } else {
      $autoplay = "";
    }

    if($this.hasClass('swiper--snap')) {
      $freemode = false;
    } else {
      $freemode = true;
    }

    if($this.find(".swiper-pagination").length) {
      $pagination = '.pagination-' + index;
    } else {
      $pagination = null;
    }
    if($this.find(".swiper-pagination--fraction").length) {
      $pagination_type = 'fraction';
    } else {
      $pagination_type = 'bullets';
    }

    if($this.find(".swiper-button-next").length) {
      $next = '.next-' + index;
    } else {
      $next = null;
    }

    if($this.find(".swiper-button-prev").length) {
      $prev = '.prev-' + index;
    } else {
      $prev = null;
    }    

    if($this.find(".swiper-scrollbar").length) {
      $scrollbar = '.scrollbar-' + index;
    } else {
      $scrollbar = null;
    }
    swiperInstances[index] = new Swiper(".swiper-" + index, {
      autoplay: $autoplay,
      slidesPerView: 'auto',
      centerInsufficientSlides: true,
      navigation: {
        prevEl: $prev,  
        nextEl: $next, 
      },
      pagination: {
        el: $pagination,
        type: $pagination_type,
        clickable: true
      },
      scrollbar: {
        el: $scrollbar,
        draggable: true,
        snapOnRelease: false,
      },
      mousewheel: {
        forceToAxis: true,
      },
      freeMode: {
        enabled: $freemode,
        minimumVelocity: 0,
        momentumBounce: false,
        momentumRatio: 0.5,
        momentumVelocityRatio: 1.5,
      }
    });
    }
  });
  setTimeout(function () {
    for (const slider of swiperInstances) {
      if (slider!=undefined) {
        slider.update();
        if(slider.isLocked == true) {
          var current = $(slider.el).children(".swiper-nav");
          $(current).addClass('swiper-nav--locked');
        }
        slider.on('lock', function () {
          var current = $(slider.el).children(".swiper-nav");
          $(current).addClass('swiper-nav--locked');
        });
        slider.on('unlock', function () {
          var current = $(slider.el).children(".swiper-nav");
          $(current).removeClass('swiper-nav--locked');
        });
        var id = $(slider.el).attr('id');
      }
    }
  }, 50);
}

// Swiper Slider - Product Page
if ($('.swiper--product-images').length > 0) {
  const productThumbsSwiper = new Swiper(".swiper--product-thumbs", {
    slidesPerView: 'auto',
    direction: 'vertical',
    watchSlidesProgress: true,
  });
  productImagesSwiper = new Swiper(".swiper--product-images", {
    pagination: {
      el: ".swiper-pagination--product-images",
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next--product-images",
      prevEl: ".swiper-button-prev--product-images",
    },
    thumbs: {
      swiper: productThumbsSwiper,
    },
  });
}

// Show Loading Overlay
function loader(isShow) {
  if (isShow) {
    $('.loader').show();
  }
  else {
    $('.loader').hide();
  }
}

// General Accordion
$('.faqs-accordion__title').off('click keypress').on('click keypress', function (event) {
  if (event.type === 'click' || (event.type === 'keypress' && (event.key === 'Enter' || event.keyCode === 13))) {
    if ($(this).hasClass('active')) {
      $('.faqs-accordion__title').next().slideUp();
      $('.faqs-accordion__title').removeClass('active');
      $('.faqs-accordion__title').attr('aria-expanded', 'false');
    } else {
      $('.faqs-accordion__title').attr('aria-expanded', 'false');
      $('.faqs-accordion__title').removeClass('active');
      $('.faqs-accordion__title').next().slideUp();
      $(this).next().slideDown();
      $(this).addClass('active');
      $(this).attr('aria-expanded', 'true');
    }
  }
});

// Product Accordion
$('.product-accordion__title').off('click keypress').on('click keypress', function (event) {
  if (event.type === 'click' || (event.type === 'keypress' && (event.key === 'Enter' || event.keyCode === 13))) {
    if($(this).hasClass('active')) {
      $('.product-accordion__title').next().slideUp();
      $('.product-accordion__title').removeClass('active');
      $('.product-accordion__title').attr('aria-expanded','false');
    } else {
      $('.product-accordion__title').attr('aria-expanded','false');
      $('.product-accordion__title').removeClass('active');
      $('.product-accordion__title').next().slideUp();
      $(this).next().slideDown();
      $(this).addClass('active');
      $(this).attr('aria-expanded','true');
    }
  }
});

// Cart Discount
function updateCartDiscount(discountCode) {
  const cartId=getCookie('cart') ? `gid://shopify/Cart/${getCookie('cart')}` : '';
  if (cartId != '' )  {
    const _var={
      cartId:cartId,
      discountCodes:discountCode
    };
    FetchDataWithVariables(`
      mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
        cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
          cart {
            id
            discountCodes {
              code
            }
          }
          userErrors {
            field
            message
          }
        }
      }
      `,_var,function(data) {
        _updateCartContent(discountCode!=''?true:false);
      }
    );
  }
}

document.querySelectorAll('[data-action="discountcode"]').forEach(element => {
  element.addEventListener('click',function() {
    updateCartDiscount(document.querySelector('[data-discountcode]').value);
  });
});

document.querySelectorAll('[data-action="discountremove"]').forEach(element => {
  element.addEventListener('click',function() {
    updateCartDiscount('');
    $('#discount').val('');
  });
});

// Product Page - Qty Buttons
$(document).ready(function () {
  $('.product-add__quantity-add').on('click', function () {
    const $input = $(this).siblings('[data-quantity-input]');
    const currentVal = parseInt($input.val()) || 1;
    $input.val(currentVal + 1).change();
  });

  $('.product-add__quantity-minus').on('click', function () {
    const $input = $(this).siblings('[data-quantity-input]');
    const currentVal = parseInt($input.val()) || 1;
    if (currentVal > 1) {
      $input.val(currentVal - 1).change();
    }
  });
});

// Product Page - Add Judgeme link / Scroll Link
document.addEventListener("DOMContentLoaded", function () {
  // Replace span with anchor link
  const span = document.querySelector(".jdgm-prev-badge__text");
  if (span) {
    const link = document.createElement("a");
    link.href = "#judgeme_product_reviews";
    link.className = span.className + " scroll-link";
    link.innerHTML = span.innerHTML;
    span.replaceWith(link);
  }

  // Smooth scroll for all .scroll-link clicks
  document.addEventListener("click", function (e) {
    const target = e.target.closest(".scroll-link");
    if (target && target.hash) {
      const targetEl = document.querySelector(target.hash);
      if (targetEl) {
        e.preventDefault();
        targetEl.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  });
});

// Metaobject Swatch Hover Function
function showSwatchData(e,t) {
  const swatch = t!='click'?e.target:e.target.closest('a.swatches__col');
  const productCard = swatch.closest('.product-card');
  const productImage = productCard.querySelector('.product-card__image');
  const productTitle = productCard.querySelector('.product-card__title');
  const productPrice = productCard.querySelector('.product-card__price-current');
  const productComparePrice = productCard.querySelector('.product-card__price-compare');
  const productLink = productCard.querySelector('.product-card__image-link');
  const titleLink = productCard.querySelector('.product-card__title');
  const savingText = productCard.querySelector('.product-card__price-saving');
  const priceContainer = productCard.querySelector('.product-card__price');
  const overlayContainer = productCard.querySelector('.product-card__overlays');
  const overlay = productCard.querySelector('.product-card__overlay');
  const ds = t=='mouseenter'?swatch.dataset:(t=='mouseleave'?productCard.dataset:e.target.closest('a.swatches__col').dataset);

  if (t!='click' || !productLink.href.endsWith(ds.productUrl)) {
    e.preventDefault();
  }
  // Update with swatch data
  if (ds.imageUrl) {
    productImage.src = ds.imageUrl;
    productImage.srcset = ds.imageSrcset || '';
  }
  
  if (ds.title) {
    productTitle.textContent = ds.title;
    productTitle.title = ds.title;
  }
  
  if (ds.price) {
    productPrice.textContent = ds.price;
  }

  if (ds.comparePrice && ds.onSale === 'true') {
    savingText.textContent = ds.saving;
    savingText.style.display = 'inline';
  } else {
    savingText.style.display = 'none';
  }
  
  // Handle compare price and sale state
  if (ds.comparePrice && ds.onSale === 'true') {
    productComparePrice.textContent = ds.comparePrice;
    productComparePrice.style.display = 'inline';
    priceContainer.classList.add('product-card__price--on-sale');
  } else {
    productComparePrice.style.display = 'none';
    priceContainer.classList.remove('product-card__price--on-sale');
  }
  
  // Handle overlay
  if (ds.overlayText) {
    if (overlay) {
      overlay.textContent = ds.overlayText;
      // Clear existing classes and set new ones
      let overlayClasses = 'product-card__overlay';
      if (ds.overlayPosition) {
        overlayClasses += ` ${ds.overlayPosition}`;
      }
      if (ds.overlayColour) {
        overlayClasses += ` ${ds.overlayColour}`;
      }
      overlay.className = overlayClasses;
    } else {
      // Create overlay if it doesn't exist
      const newOverlay = document.createElement('div');
      let overlayClasses = 'product-card__overlay';
      if (ds.overlayPosition) {
        overlayClasses += ` ${ds.overlayPosition}`;
      }
      if (ds.overlayColour) {
        overlayClasses += ` ${ds.overlayColour}`;
      }
      newOverlay.className = overlayClasses;
      newOverlay.textContent = ds.overlayText;
      overlayContainer.appendChild(newOverlay);
    }
    overlayContainer.style.display = 'block';
  } else {
    overlayContainer.style.display = 'none';
  }
  
  // Update links
  if (ds.productUrl) {
    productLink.href = ds.productUrl;
    titleLink.href = ds.productUrl;
  }  
}

// Output Metaobject Swatch Hover Function
document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('mouseenter', function(e) {
    if (window.innerWidth>599 && e.target && e.target.classList && e.target.classList.contains('swatches__col') && e.target.closest('.product-card__swatches')) {        
      showSwatchData(e,'mouseenter');        
    }
  }, true);
  document.addEventListener('mouseleave', function(e) {
    if (window.innerWidth>599 && e.target && e.target.classList && e.target.classList.contains('swatches__col') && e.target.closest('.product-card__swatches')) {        
      showSwatchData(e,'mouseleave');  
    }
  }, true);
  document.addEventListener('click', function(e) {
    if (window.innerWidth<600 &&  e.target && e.target.closest('a.swatches__col') && e.target.closest('.product-card__swatches')) {        
      showSwatchData(e,'click');        
    }
  }, true);
});